import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {CopyIcon} from 'shells/icon/svg/copy-icon';

import {OpenableModals, useOpenableModal} from '../../../../openable-modals';

import {useGetContextDocumentUsage} from '../../graphql/hooks/use-get-context-document-usage';

import {ANIMATION_SRC} from '../consts';

import {ChatOnboardingLayout} from './chat-onboarding-layout';

export function EmbedChatbot() {
    const {onOpen} = useOpenableModal(OpenableModals.EMBED_ANALYTICS_MODAL);

    const {refetch: refetchContextDocumentUsage} = useGetContextDocumentUsage();

    React.useEffect(() => {
        refetchContextDocumentUsage();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ChatOnboardingLayout
            title='Looks great, huh?'
            subtitle='To launch your Engagement bar just paste this Nutshell snippet into the <head> of your site — or do this later.'
            animation={<Rive src={ANIMATION_SRC.EMBED_CHATBOT} />}
            actionComponent={
                <Button variant='primary' size='big' onClick={onOpen} icon={CopyIcon}>
                    Embed Chatbot
                </Button>
            }
        />
    );
}
